<section class="principal">
  <section class="section" *ngIf="inProcess == true">
    <h1>Aguarde enquanto validamos o seu acesso na ferramenta...</h1>
  </section>
  
  <section class="section" *ngIf="inProcess == false && showError == true">
    <h1>Olá {{userOAuth?.givenName}}!</h1>
    <br>
    <h3>{{errorMessage}}</h3>
    <button *ngIf="accessDenied == false" class="btn btn-primary" routerLink="/" rippleEffect>Tentar novamente!</button>
  </section>
  
  <section class="section" *ngIf="inLoadProfile == true">
    <h1>Olá {{userOAuth?.givenName}}!</h1>
    <br>
    <h3>Aguarde mais um instante enquanto carregamos o seu perfil....</h3>
  </section>
  
  <section class="section" *ngIf="inProcess == false && showChoose == true">
    <h1 >Olá {{userOAuth?.givenName}}!</h1>
    <br>
    <h3 >Escolha uma opção abaixo para acessar a plataforma:</h3>
    <div class="contentCard container-fluid">
      <div class="card container-fluid">
        <div>
          <!--img class="img" [src]="imageCard1"  alt="imagem card para portal de usuário"/-->
          <div class="contentTituloMsg">
            Portal do usuário
          </div>
        </div>
        <div></div>
        <button class="btn btn-primary" routerLink="/portal/home" rippleEffect>Acessar</button>
     
        <div class="footer"></div>
      </div>
      <div class="card container-fluid">
        <div>
          <!--img class="img" [src]="imageCard2" alt="imagem card para acesso administrador"/-->
          <div class="contentTituloMsg">
            Módulo Administrativo
          </div>
        </div>
        <div></div>
        <button class="btn btn-primary" routerLink="/admin/home" rippleEffect>Acessar</button>
    
        <div class="footer"></div>
      </div>
    </div>
  </section>
</section>